// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"794":"record-detail","893":"record-list"}[chunkId] + "." + {"794":"c498804c","893":"4643eef8"}[chunkId] + ".css";
};